import { render, staticRenderFns } from "./PaymentControl.vue?vue&type=template&id=229a6e70&scoped=true"
import script from "./PaymentControl.vue?vue&type=script&lang=js"
export * from "./PaymentControl.vue?vue&type=script&lang=js"
import "./PaymentControl.vue?vue&type=style&index=0&id=229a6e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a6e70",
  null
  
)

export default component.exports